import { render, staticRenderFns } from "./NewsCard.vue?vue&type=template&id=62c09115&scoped=true"
import script from "./NewsCard.vue?vue&type=script&lang=js"
export * from "./NewsCard.vue?vue&type=script&lang=js"
import style0 from "./NewsCard.vue?vue&type=style&index=0&id=62c09115&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c09115",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c09115')) {
      api.createRecord('62c09115', component.options)
    } else {
      api.reload('62c09115', component.options)
    }
    module.hot.accept("./NewsCard.vue?vue&type=template&id=62c09115&scoped=true", function () {
      api.rerender('62c09115', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News/NewsCard.vue"
export default component.exports